export default {
      id: "restons_co-usage",
      viewBox: "0 0 125 120",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#restons_co-usage",
      toString: function () {
        return this.url;
      }
    }